import { IGroupWithIds } from "../_models/IGroupWithIds";

export class GroupsHierarchyHelper {
    static getParents(group: IGroupWithIds, includeCurrentGroup = false): IGroupWithIds[] {
        const parents: IGroupWithIds[] = [];
        let currentGroup = includeCurrentGroup ? group : group.parent;

        while (currentGroup) {
            parents.push(currentGroup);
            currentGroup = currentGroup.parent;
        }

        return parents;
    }

    static find(callback: (group: IGroupWithIds) => boolean, hierarchy: IGroupWithIds[]): IGroupWithIds {
        for (const group of hierarchy) {
            if (callback(group)) {
                return group;
            }

            if (group.children && group.children.length > 0) {
                const found = this.find(callback, group.children);
                if (found) {
                    return found;
                }
            }
        }

        return null;
    }

    static filter(callback: (group: IGroupWithIds) => boolean, hierarchy: IGroupWithIds[]): IGroupWithIds[] {
        let groups: IGroupWithIds[] = [];

        for (const group of hierarchy) {
            if (callback(group)) {
                groups.push(group);
            }

            if (group.children && group.children.length > 0) {
                const found = this.filter(callback, group.children);
                groups = [...groups, ...found];
            }
        }

        return groups;
    }

    static some(callback: (group: IGroupWithIds) => boolean, hierarchy: IGroupWithIds[]): boolean {
        for (const group of hierarchy) {
            if (callback(group)) {
                return true;
            }

            if (group.children && group.children.length > 0) {
                if (this.some(callback, group.children)) {
                    return true;
                }
            }
        }

        return false;
    }
}